import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x"
      style={{
        background: "linear-gradient(to bottom, rgba(0,0,0,0.35), rgba(0,0,0,0.1))",
        padding: "10px 0",
      }}
    >
      <div
        className="container-fluid content"
        style={{
          paddingLeft: "40px",   // 🔥 left spacing
          paddingRight: "40px",  // 🔥 right spacing
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        
        {/* LOGO */}
        <a className="navbar-brand" href="#">
          <img
            src="/home1/assets/img/logo_dark.png"
            alt=""
            className="logo"
            style={{
              height: "65px",
              filter: "brightness(0) invert(1)",
            }}
          />
        </a>

        {/* RIGHT ICON */}
        <div className="nav-side">
          <a
            href="#"
            className="icon side_menu_btn"
            style={{
              color: "#fff",
              fontSize: "45px",
            }}
          >
            <i className="la la-grip-lines"></i>
          </a>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;
